module.exports = __webpack_public_path__ + "img/Team_photo_IMG_8716_DxO_960x224.5fa3a728.jpg";